import { render, staticRenderFns } from "./association_exhibition.vue?vue&type=template&id=48dcbad4&scoped=true"
import script from "./association_exhibition.vue?vue&type=script&lang=js"
export * from "./association_exhibition.vue?vue&type=script&lang=js"
import style0 from "./association_exhibition.vue?vue&type=style&index=0&id=48dcbad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcbad4",
  null
  
)

export default component.exports